module.exports = __webpack_public_path__ + "static/media/tooltip-bottom--gray.34e09e34.svg";